
































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DxScrollView } from "devextreme-vue";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import notificationService from "@/services/notificationService";
import DataSource from "devextreme/data/data_source";
import dxCustomStore from "devextreme/data/custom_store";
import InvoiceBookmarkReplacer from "@/helpers/invoiceBookmarkReplacer";
import { MailConfig } from '@/installationConfig';

import {
  ContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  MailTemplatesClient,
  MailTemplateType,
  IMailTemplateDto,
  ProjectContactsClient,
  IMailInvoiceCommand,
  IInvoiceDto,
  InvoicesClient,
  MailInvoiceCommand,
  ProjectsClient,
  ProjectBasicInfoDto,
  InvoiceDto,
  SettingsClient,
} from "@/data/web-api-client";

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxEmailRule,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";

import { DxHtmlEditor } from "devextreme-vue/html-editor";

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class MailPopupRappel extends Vue {
  private show: boolean = false;
  private sending: boolean = false;
  private fullscreen: boolean = false;
  private formdata: IMailInvoiceCommand | any = {
    template: "",
    sendSms: true,
    from: "",
    to: [],
    cc: [],
    subject: "",
    content: "",
    objectIds: [],
  };
  private templates: IMailTemplateDto[] = [];
  private project: ProjectBasicInfoDto | null = null;
  private currentGroup: number = 0;

  private invoices!: IInvoiceDto[];
  private groupedInvoices: any[] = [];

  public open(groupedInvoices: any[]) {
    this.groupedInvoices = groupedInvoices;
    this.start()
  }

  private start() {
    if (!this.groupedInvoices.length) {
      return;
    }

    this.invoices = [];
    this.invoices = this.groupedInvoices[this.currentGroup];

    this.formdata.to.splice(0, this.formdata.to.length);
    this.formdata.cc.splice(0, this.formdata.cc.length);
    this.loadProjectContacts();
    this.loadProject();

    if (
      this.invoices[0].customerContact &&
      this.invoices[0].customerContact.email &&
      this.invoices[0].customerContact.email !== ""
    ) {
      (this.formdata.to as string[]).push(
        this.invoices[0].customerContact.email
      );
    } else if (
      this.invoices[0].customer &&
      this.invoices[0].customer.email &&
      this.invoices[0].customer.email !== ""
    ) {
      (this.formdata.to as string[]).push(this.invoices[0].customer.email);
    }

    this.invoices.forEach((invoice) => {
      this.formdata.objectIds.push(invoice.id);
    });

    const lastUsedEmail = localStorage.getItem("invoice_last_used_email");
    const lastUsedTemplate = localStorage.getItem("invoice_last_used_template");
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (this.settings && this.settings.paymentReminderTemplate && this.settings.paymentReminderTemplate) {
      const template = this.templates.find(t => t.id === this.settings.paymentReminderTemplate);

      if (template) {
        this.formdata.template = template.name;
        this.formdata.subject = template.subject ? template.subject : "";
        this.formdata.content = template.content ? template.content : "";

        this.makeFormContentReadyForMultipleInvoices();

        this.invoices.forEach((invoice) => {
          this.replaceTags(invoice);
        });
      }
    }

    this.show = true;
  }

  private restart(){
    this.formdata = {
      template: "",
      sendSms: true,
      from: "",
      to: [],
      cc: [],
      subject: "",
      content: "",
      objectIds: [],
    }

    this.currentGroup++;
    this.start();
  }

  private async loadProject() {
    if (!this.invoices[0].projectId || this.invoices[0].projectId === "") {
      return;
    }

    this.project = await new ProjectsClient(
      undefined,
      this.$axios
    ).getProjectBasicInfo(this.invoices[0].projectId);

    this.invoices.forEach((invoice) => {
      this.replaceTags(invoice);
    });
  }

  private async loadProjectContacts() {
    if (!this.invoices[0].projectId || this.invoices[0].projectId === "") {
      return;
    }

    await this.contactDataSource.load();

    const res = await new ProjectContactsClient(
      undefined,
      this.$axios
    ).getContacts(this.invoices[0].projectId);
    res.forEach((contact) => {
      if (
        contact.sendInvoice &&
        contact.contact &&
        contact.contact.email &&
        contact.contact.email !== ""
      ) {
        if (this.formdata.to.indexOf(contact.contact.email) === -1) {
          this.formdata.to.push(contact.contact.email);
        }
      }
    });
  }

  private async created() {
    try {
      this.templates = await new MailTemplatesClient(
        undefined,
        this.$axios
      ).getAll(MailTemplateType.Invoicing);
    } catch {
      // do nothing
    }
  }

  private replaceTags(invoice: IInvoiceDto) {
    try {
      InvoiceBookmarkReplacer.Replace(this.formdata, invoice, this.project!);
    } catch {
      // do nothing
    }
  }

  private async send() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;
      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content
        .replaceAll("<p>", "<div>")
        .replaceAll("</p>", "</div>");
      await new InvoicesClient(undefined, this.$axios).mail(
        new MailInvoiceCommand(this.formdata)
      );
      notificationService.showSuccessMessage("Mail verstuurd, eventuele volgende mail gegevens worden geladen");
      if(this.groupedInvoices.length != this.currentGroup+1){
        this.restart();
      }
      else{
        this.invoices = [];
        this.groupedInvoices = [];
        this.show = false;
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "separator",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          "separator",
          "orderedList",
          "bulletList",
          "separator",
          "link",
          "separator",
          {
            formatName: "size",
            formatValues: [
              "8pt",
              "10pt",
              "12pt",
              "14pt",
              "18pt",
              "24pt",
              "36pt",
            ],
          },
          {
            formatName: "header",
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: "id",
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (
            loadOptions.searchExpr &&
            loadOptions.searchOperation &&
            loadOptions.searchValue
          ) {
            loadOptions.filter = [
              [
                "displayName",
                loadOptions.searchOperation,
                loadOptions.searchValue,
              ],
              "or",
              ["email", loadOptions.searchOperation, loadOptions.searchValue],
            ];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: this.invoices[0].projectId,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.invoices
        ? this.invoices[0].projectId
          ? false
          : true
        : false,
    });
  }

  get contactOptions() {
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ["email", "displayName"],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return "undefined";
        }

        if (typeof item === "string") {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return "";
        }

        if (typeof val === "string") {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: "name",
      displayExpr: "name",
      onItemClick: (e: any) => {
        self.formdata.subject = e.itemData.subject;
        self.formdata.content = e.itemData.content;

       self.makeFormContentReadyForMultipleInvoices();
        (this.$refs.form as DxForm).instance!.repaint();

        this.invoices.forEach((invoice) => {
          self.replaceTags(invoice);
        });
      },
    };
  }

  private makeFormContentReadyForMultipleInvoices(){
    var indexOfFirst = this.formdata.content.indexOf("$");
        var indexOfLast = this.formdata.content.lastIndexOf("$");

        if (indexOfFirst != -1 && indexOfLast != -1) {
          var fistPart = this.formdata.content.substring(0, indexOfFirst);
          var lastPart = this.formdata.content.substring(
            indexOfLast + 1,
            this.formdata.content.length
          );
          var middlePart = this.formdata.content
            .substring(indexOfFirst + 1, indexOfLast)
            .trim();

          var newMiddlePart = "";
          for (var i = 0; i < this.invoices.length; i++) {
            newMiddlePart += middlePart;
            newMiddlePart += "</br>";
          }

          this.formdata.content = fistPart + newMiddlePart + lastPart;
        }
  }

  get settings() {
    return this.$store.getters['settings/data'];
  }
}
